import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import CampaignAddOn from './components/CampaignAddOn';
import MedicalHistoryForm from './components/MedicalHistoryForm';
import './App.css';

function CampaignAddOnWithNav() {
  const navigate = useNavigate();
  return <CampaignAddOn onNext={() => navigate('/riwayat-medis')} />;
}

function MedicalHistoryFormWithNav() {
  const navigate = useNavigate();
  return <MedicalHistoryForm onBack={() => navigate('/')} />;
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<CampaignAddOnWithNav />} />
          <Route path="/riwayat-medis" element={<MedicalHistoryFormWithNav />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
